<template>
  <div
    class="list-meta__item"
    :class="{
      'list-meta__item--name': isName,
      'w-full': fullWidth
    }"
  >
    <i v-if="icon" :class="`fa fa-${icon} fa-fw`"></i>
    <span v-if="label" class="list-meta__label">
      <slot name="key"></slot>
    </span>
    <span class="list-meta__text"><slot></slot></span>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: null
    },
    isName: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    label: {
      type: Boolean,
      default: true
    }
  }
}
</script>
